import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class DistributorsProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('distributors', query)
  }

  getItemById (id) {
    this.setHeader(getAuthToken())
    return this.get(`distributors/${id}`)
  }

  createItem (payload) {
    this.setHeader(getAuthToken())
    return this.post('distributors', payload)
  }

  updateItem (payload) {
    this.setHeader(getAuthToken())
    return this.put(`distributors/${payload.id}`, payload)
  }

  deleteItem (id) {
    this.setHeader(getAuthToken())
    return this.delete(`distributors/${id}`)
  }
}

export default DistributorsProvider
